$wj([56],{

/***/ 2335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setFocusedInboxOnOff_1 = __webpack_require__(4638);
exports.setFocusedInboxOnOff = setFocusedInboxOnOff_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 4638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var setIsFocusedCapableService_1 = __webpack_require__(1898);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
var owa_mail_list_actions_1 = __webpack_require__(80);
var updateAlwaysInCacheTableIds_1 = __webpack_require__(798);
var owa_mail_list_store_1 = __webpack_require__(5);
var owa_mail_table_loading_actions_1 = __webpack_require__(63);
var userConfigurationDictionaryEntry_1 = __webpack_require__(116);
var userConfigurationDictionaryObject_1 = __webpack_require__(117);
var owa_session_store_1 = __webpack_require__(151);
var updateUserConfiguration_1 = __webpack_require__(153);
var folderIdToName_1 = __webpack_require__(48);
var legacy_1 = __webpack_require__(1);
/**
 * Set Focused inbox On/Off
 * @param isFocusedInboxEnabled - Switch flag to indicate if Focused Inbox should be switched On/Off
 * @param skipServiceRequest - Whether to skip the service request to save the setting. Used when called as part of Options stitch
 */
exports.default = legacy_1.action('setFocusedInboxOnOff')(function setFocusedInboxOnOff(isFocusedInboxEnabled, skipServiceRequest) {
    var folderIdForSelectedNode = owa_mail_folder_forest_store_1.getFolderIdForSelectedNode();
    // Reload selected folder only if it is Inbox
    if (folderIdToName_1.default(folderIdForSelectedNode) === 'inbox') {
        var tableQuery = owa_mail_list_actions_1.createMailFolderTableQuery(folderIdForSelectedNode, owa_mail_list_store_1.getListViewTypeForFolder(folderIdForSelectedNode), isFocusedInboxEnabled ? 0 /* Focused */ : -1 /* None */, 'All');
        owa_mail_table_loading_actions_1.loadTableViewFromTableQuery(tableQuery);
    }
    if (!skipServiceRequest) {
        // update userOptions property and save the setting
        owa_session_store_1.getUserConfiguration().UserOptions.IsFocusedInboxEnabled = isFocusedInboxEnabled;
        updateUserConfiguration_1.default('OWA.UserOptions', [
            userConfigurationDictionaryEntry_1.default({
                DictionaryKey: userConfigurationDictionaryObject_1.default({
                    Type: 'String',
                    Value: ['IsFocusedInboxEnabled'],
                }),
                DictionaryValue: userConfigurationDictionaryObject_1.default({
                    Type: 'Boolean',
                    Value: [String(isFocusedInboxEnabled)],
                }),
            }),
        ]);
        // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
        if (isFocusedInboxEnabled) {
            setIsFocusedCapableService_1.setIsFocusedInboxCapableService();
        }
    }
    updateAlwaysInCacheTableIds_1.default();
});
//# sourceMappingURL=setFocusedInboxOnOff.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.FocusedInboxConfigActions.js